import { Box, Icon, IconSize } from '@bechtel/gds';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { map } from 'lodash';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { MoreOptionsItem, MultiLingualText, navbarIcons } from '~/components';
import { ContainerStyled, IconWrapperStyled, MoreOptionsLinkStyled } from './styled';

export interface NavItem {
  icon: IconName;
  title: string;
  path: string;
  parentPath: string;
  default?: boolean;
}

interface NavbarItemsProps {
  items: MoreOptionsItem[];
  showMore?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NavbarItems: FC<NavbarItemsProps> = ({ items, showMore }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} alignItems={{ sm: 'center' }} mt={{ sm: '200' }}>
      {items.length > 0 &&
        map(items, ({ title, path, parentPath, default: defaultValue }: NavItem, index: number) => {
          const IconComponent = navbarIcons[path];
          return (
            <NavLink to={`/${parentPath}/${path}`} key={path} style={{ textDecoration: 'none' }}>
              {({ isActive }) => (
                <ContainerStyled key={index} active={isActive} border={!defaultValue}>
                  <IconWrapperStyled>
                    {IconComponent ? <IconComponent /> : <Icon icon="table-cells" iconStyle="duo" />}
                  </IconWrapperStyled>
                  <MultiLingualText
                    style={{ whiteSpace: 'break-spaces' }}
                    color="grey.100"
                    family="openSansCondensed"
                    weight="400"
                    size={300}
                  >
                    {title}
                  </MultiLingualText>
                </ContainerStyled>
              )}
            </NavLink>
          );
        })}
      {showMore && (
        <MoreOptionsLinkStyled to="#" onClick={() => showMore((prev) => !prev)}>
          <ContainerStyled active={false} border={false} alignItems={{ sm: 'center' }}>
            <Icon icon="ellipsis" iconStyle="solid" size={IconSize.LARGE} fillColor="grey.100" />
          </ContainerStyled>
        </MoreOptionsLinkStyled>
      )}
    </Box>
  );
};

export default NavbarItems;
